import React, { useState, useEffect } from "react";
import Title from "../../components/title/title";
import CardListTwo from "../../components/card/cardTwo";
// import SelectModal from "../../components/modal/selectModal";
import AddButton from "../../components/button/addbutton";
import Img from "../../assets/subjects.png";

import { useSelector, useDispatch } from "react-redux";
import { manageYear } from "../../data/Reducers/YearReducer";
import { LoadingLoader } from "../../components/button/button";
import { AddYearModal } from "../../components/modal/addModal";
import { useNavigate } from "react-router-dom";

const ManageYears = () => {
	const [isSelectModalOpen, setIsSelectModalOpen] = useState(false);

	// const cardsData = [
	// 	{
	// 		icon: Img,
	// 		title: "BIOLOGY STUDIES",
	// 		id: 1,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "MATHEMATICS",
	// 		id: 2,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "ENGLISH LANGUAGE",
	// 		id: 3,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "COMPUTER SCIENCE",
	// 		id: 4,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "CATERING & ART",
	// 		id: 5,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "YORUBA LANGUAGE",
	// 		id: 6,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "CHEMISTRY",
	// 		id: 7,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "LIT-IN ENGLISH",
	// 		id: 8,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "HOME ECONOMICS",
	// 		id: 9,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "MATHEMATICS",
	// 		id: 10,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "ENGLISH LANGUAGE",
	// 		id: 11,
	// 	},
	// 	{
	// 		icon: Img,
	// 		title: "COMPUTER SCIENCE",
	// 		id: 12,
	// 	},
	// ];

	const selectOpenModal = () => {
		setIsSelectModalOpen(true);
	};

	// const closeSelectModal = () =>{
	//   setIsSelectModalOpen(false)
	// }

	let { year } = useSelector(s => s),
		[data, setData] = useState(null),
		dispatch = useDispatch(),
		navigate = useNavigate();

	useEffect(() => {
		setData(year?.data);
	}, [year?.data]);

	useEffect(() => {
		dispatch(manageYear("get", null));
	}, [dispatch]);

	if (!data && !year?.data) return <LoadingLoader />;

	return (
		<div className="w-[85%] m-auto">
			<div className="">
				<Title title="MANAGE YEARS" />
				<div className="mt-6 mb-8 flex justify-between items-center gap-4">
					<div className="flex items-center gap-3">
						<AddButton
							onClick={() => navigate(-1)}
							title={"Back"}
							type="back"
						/>
						<h2 className="text-2xl">All Years</h2>
					</div>
					<AddButton onClick={selectOpenModal} />
				</div>

				<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mt-8 ">
					{data?.docs?.map((card, index) => (
						<CardListTwo
							key={index}
							title={card?.title}
							icon={Img}
							// to="/manage-exams/question"
							item={card}
							type="Year"
						/>
					))}
				</div>

				{/* <div>
                <CardListTwo cards={cards} />
            </div> */}
			</div>
			<AddYearModal
				isOpenAddModal={isSelectModalOpen}
				closeAddModal={() => setIsSelectModalOpen(false)}
				isOpenSelectModal={isSelectModalOpen}
			/>
		</div>
	);
};

export default ManageYears;
